import { FetchProcedureWithPresentedDocumentationCommand } from './FetchProcedureWithPresentedDocumentationCommand'
import { ApplicantNif, DocumentationType } from '@/Domain/Documentation'
import { PresentedDocumentationRepository } from '@/Domain/Documentation/Presented'

export class FetchProcedureWithPresentedDocumentationCommandHandler {
  private _repository: PresentedDocumentationRepository

  constructor (repository: PresentedDocumentationRepository) {
    this._repository = repository
  }

  async handle (command: FetchProcedureWithPresentedDocumentationCommand): Promise<string[]> {
    try {
      const applicantNif = new ApplicantNif(command.applicantNif())
      const documentType = DocumentationType.fromIntegerCode(command.documentType())
      const result = await this._repository.proceduresWithPresentedDocumentation(applicantNif, documentType)
      const parsedResult = result.map(current => {
        return current.procedureCode
      })
      return Promise.resolve(parsedResult)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
